var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconAnnouncement(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5625 8.4375C12.7706 8.4375 13.75 7.45812 13.75 6.25C13.75 5.04188 12.7706 4.0625 11.5625 4.0625V8.4375Z",
    fill: "#F3B763"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.24999 3.4375H4.0625C2.5092 3.4375 1.25 4.6967 1.25 6.25C1.25 7.8033 2.5092 9.0625 4.0625 9.0625H6.25L6.24999 3.4375Z",
    fill: "#F3B763"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 8.75025L3.48415 12.6869C3.51183 12.7976 3.52567 12.8529 3.54204 12.9013C3.70198 13.3734 4.1272 13.7055 4.62408 13.7461C4.67494 13.7502 4.732 13.7502 4.84612 13.7502C4.98903 13.7502 5.06048 13.7502 5.12067 13.7444C5.71562 13.6867 6.18646 13.2159 6.24416 12.6209C6.25 12.5607 6.25 12.4893 6.25 12.3464V3.43775M11.5625 8.43775C12.7706 8.43775 13.75 7.45837 13.75 6.25025C13.75 5.04213 12.7706 4.06275 11.5625 4.06275M6.40625 3.43775H4.0625C2.5092 3.43775 1.25 4.69695 1.25 6.25025C1.25 7.80355 2.5092 9.06275 4.0625 9.06275H6.40625C7.51027 9.06275 8.86078 9.65455 9.90269 10.2225C10.5105 10.5539 10.8144 10.7195 11.0135 10.6952C11.1981 10.6726 11.3376 10.5897 11.4458 10.4384C11.5625 10.2753 11.5625 9.949 11.5625 9.29632V3.20418C11.5625 2.5515 11.5625 2.22516 11.4458 2.06206C11.3376 1.91081 11.1981 1.82794 11.0135 1.80533C10.8144 1.78095 10.5105 1.94662 9.90269 2.27797C8.86078 2.84595 7.51027 3.43775 6.40625 3.43775Z",
    stroke: "#222222",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAnnouncement);
export default __webpack_public_path__ + "static/media/icon-announcement.5759acf5b1cfca3e8d9bad6a890c7989.svg";
export { ForwardRef as ReactComponent };